import styled from "@emotion/styled";
import React from "react";

import { TICKET_TYPE, TICKET_TYPE_STRING } from "@src/components/deungi/common/enum";

import CommonPackageListBox from "./CommonPackageListBox";
import ExpertPaymentInfoBox from "@src/components/expert/ticket/ExpertPaymentInfoBox";
import CommonTicketItem from "@src/components/expert/ticket/CommonTicketItem";

import companion_ticket_ico from "@src/assets/expert/ticket/accompanyIcon.png";

const ExpertCompanionPackageListBox = () => {
    const ticketImage = companion_ticket_ico;
    const ticketTypeString = TICKET_TYPE_STRING.COMPANION_TICKET;
    const ticketTitle = "임장동행 전문가 매칭 이용권";
    return (
        <Container>
            <TicketContainer>
                <CommonTicketItem
                    ticketTypeNumber={TICKET_TYPE.COMPANION_TICKET}
                    ticketTitle="임장동행 전문가매칭 이용권"
                    ticketImage={ticketImage}
                />
            </TicketContainer>
            <PackageListBoxStyle>
                <CommonPackageListBox ticketTypeString={ticketTypeString} ticketTitle={ticketTitle} ticketImage={ticketImage} />
            </PackageListBoxStyle>
            <ExpertPaymentInfoBox ticketType={TICKET_TYPE_STRING.COMPANION_TICKET} title="임장동행 전문가매칭 이용권" />
        </Container>
    );
};

export const Container = styled.div`
    height: 100%;
    overflow: scroll;
    background-color: white;
    .backDiv {
        width: 0;
        height: 75px;
    }
`;

export const TicketContainer = styled.div`
    position: fixed;
    display: flex;
    align-items: center;
    background: #fff;
    box-sizing: border-box;
    width: 100%;
    top: 55px;
    gap: 10px;
    padding: 0 14px 14px;
    z-index: 2;

    & > div {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 10px;
    }
`;

export default ExpertCompanionPackageListBox;

export const PackageListBoxStyle = styled.div`
    margin-top: 80px;
`;
